'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useId, useRef, useState, } from 'react';
/**
 * A value clamped to `lines` lines with a disclosure button. The button is
 * rendered only when the content overflows the clamp (measured after mount
 * and on resize), so short values look exactly like unclamped ones.
 */
export function DescriptionValueClamp({ lines, expandLabel, collapseLabel, children, }) {
    const id = useId();
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [overflows, setOverflows] = useState(false);
    const measure = useCallback(() => {
        const el = ref.current;
        if (!el || expanded)
            return;
        setOverflows(el.scrollHeight - el.clientHeight > 1 || el.scrollWidth - el.clientWidth > 1);
    }, [expanded]);
    useEffect(() => {
        measure();
        const el = ref.current;
        if (!el || typeof ResizeObserver === 'undefined')
            return;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, [measure, children, lines]);
    return (_jsxs(_Fragment, { children: [_jsx("span", { ref: ref, id: id, className: "mn-dl__clamp", "data-expanded": expanded || undefined, "data-single": lines === 1 || undefined, style: { '--_lines': lines }, children: children }), overflows || expanded ? (_jsx("button", { type: "button", className: "mn-dl__expand", "aria-expanded": expanded, "aria-controls": id, onClick: () => setExpanded((v) => !v), children: expanded ? collapseLabel : expandLabel })) : null] }));
}
//# sourceMappingURL=description-list.clamp.js.map